import React, {useContext, useEffect, useState} from "react";

import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "react-toastify";

import formService from "../../services/formService";
import gs from "../../services/global";
import { toasterConfig } from "../../utils/Constant";

import ErrorMsgComp from "../../components/ErrorMsgComp";
import Header from "../../components/Header";
import InnerBgComp from "../../components/InnerBgComp";
import AuthContext from "../../store/auth-context";

const {
    REACT_APP_FLOWID,
} = process.env;

const Disabled = () => {
  const authCtx = useContext(AuthContext);
  const instanceId = authCtx?.instanceId;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  useEffect(() => {
    formService.inputEmptyCheck();
  }, []);

  const onSubmit = (data) => {
    const payload = {
      action: "submit",
      data: {
          email: data?.emailaddress,
          phoneNumber: data?.mobilenumber,
      }
    };

    gs.showLoader(true);
    setIsSubmitting(true);

    axios
      .post(`/flow/${REACT_APP_FLOWID}/instances/${instanceId}`, payload)
      .then(() => {
        gs.showLoader(false);
        setIsSubmitting(false);
        reset();
        setSubmitted(true);
        toast.success(
          "Thanks! We'll contact you when applications reopen.",
          toasterConfig
        );
      })
      .catch((error) => {
        gs.showLoader(false);
        setIsSubmitting(false);
        const message =
          error?.response?.data?.message || "Something went wrong. Please try again.";
        toast.error(message, toasterConfig);
      });
  };

  return (
    <div>
      <Header loginBtn={false} />

      <div className="main-container">
        <InnerBgComp classes={"inner-bg-img"} />

        <div className="container">
          <motion.div
            initial={{ y: 60, scale: 0.9, opacity: 0 }}
            animate={{ y: 0, scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="comm-box disabled-box"
          >
            <div className="comm-hdn-slide">
              <div className="comm-hdn-box">
                <h3 className="comm-hdn">
                  {submitted
                    ? "We've received your details"
                    : "Applications are currently full for today"}
                </h3>
                <div className="comm-para">
                  {submitted ? (
                    <>
                      <p>Thanks for your interest.</p>
                      <p>We&apos;ll contact you when applications reopen.</p>
                      <br />
                      <p>This was not a loan application.</p>
                    </>
                  ) : (
                    <p>
                      We&apos;ve reached today&apos;s application capacity. Leave your details below and we&apos;ll notify you as soon as new application slots open.
                    </p>
                  )}
                </div>
              </div>
            </div>

            {!submitted && (
              <>


                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-grp-field">
                    <div className="form-grp">
                      <input
                        className="form-field"
                        type="email"
                        id="emailaddress"
                        name="emailaddress"
                        autoComplete="email"
                        {...register("emailaddress", {
                          required: "Email is required",
                          pattern: {
                            value:
                              /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
                            message: "Enter a valid Email",
                          },
                        })}
                      />
                      <p className="form-label">Email address</p>
                    </div>
                    {errors.emailaddress && (
                      <ErrorMsgComp
                        errorMessage={errors.emailaddress.message}
                      />
                    )}
                  </div>

                  <div className="form-grp-field">
                    <div className="form-grp">
                      <input
                        className="form-field"
                        type="tel"
                        inputMode="numeric"
                        onWheel={(e) => e.target.blur()}
                        id="mobilenumber"
                        name="mobilenumber"
                        autoComplete="tel-national"
                        {...register("mobilenumber", {
                          required: "UK mobile number is required",
                          pattern: {
                            value: /^07\d{9}$/,
                            message: "Phone number must start with 07",
                          },
                          minLength: {
                            value: 11,
                            message: "Phone number must be 11 digits",
                          },
                          maxLength: {
                            value: 11,
                            message: "Phone number must be 11 digits",
                          },
                        })}
                      />
                      <p className="form-label">UK mobile number</p>
                    </div>
                    {errors.mobilenumber && (
                      <ErrorMsgComp
                        errorMessage={errors.mobilenumber.message}
                      />
                    )}
                  </div>
                  <p className="disabled-agreement">
                    By submitting I agree to be contacted via email or mobile about the application process
                  </p>
                  <button
                    className="button button--block"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    <span>Notify me</span>
                  </button>
                </form>
              </>
            )}

            <p className="disabled-support">
              Contact us by phone at{" "}
              <a href="tel:02036957544" className="contact-link">
                020 3695 7544
              </a>{" "}
              or email at{" "}
              <a href="mailto:info@creditstar.co.uk" className="contact-link">
                info@creditstar.co.uk
              </a>{" "}
              or by chat via our website.
              <br />
              Support is available Monday to Friday, 09:00-18:00 GMT
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Disabled;
